import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <motion.div initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 5,
    duration: 0.4,
    type: 'spring'
  }} className="fixed bottom-6 right-6 z-50 flex items-center gap-3 group" data-id="element-177">
      <div className="bg-white text-wellness-dark text-sm font-medium py-2 px-3 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-178">
        ¿Tienes dudas?
      </div>

      <a href="https://wa.me/524848780771" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-12 h-12 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20ba56] transition-colors" aria-label="Contactar por WhatsApp" data-id="element-179">
        <MessageCircle className="w-6 h-6" data-id="element-180" />
      </a>
    </motion.div>;
}